import React, { ReactNode } from 'react';
import Button from '@mui/material/Button';
import IntlMessages from '@crema/helpers/IntlMessages';
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide, Typography } from '@mui/material';
import { Fonts } from '@crema/constants/AppEnums';
import { TransitionProps } from '@mui/material/transitions';

// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<any, any>;
//   },
//   // eslint-disable-next-line no-undef
//   ref: React.Ref<unknown>,
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

type AppConfirmDialogProps = {
  dialogTitle: string | ReactNode;
  open: boolean;
  onDeny: (isOpen: boolean) => void;
  title: string | ReactNode;
  denyTitle?: string | ReactNode;
  confirmTitle?: string | ReactNode;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  hideCancel?: boolean;
};

const AppConfirmDialog: React.FC<AppConfirmDialogProps> = ({
  open,
  onDeny,
  onConfirm,
  title,
  dialogTitle,
  denyTitle,
  confirmTitle,
  confirmDisabled = false,
  hideCancel = false,
}) => {
  return (
    <Dialog
      // TransitionComponent={Transition}
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
    >
      <DialogTitle>
        <Typography
          sx={{
            mb: 3,
            fontWeight: Fonts.SEMI_BOLD,
          }}
          id="alert-dialog-title"
        >
          {dialogTitle}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ color: 'text.secondary', fontSize: 14 }} id="alert-dialog-description">
        {title}
      </DialogContent>
      <DialogActions
        sx={{
          pb: 5,
          px: 6,
          justifyContent: hideCancel ? 'center' : 'flex-end',
        }}
      >
        <Button
          variant={hideCancel ? 'contained' : 'outlined'}
          sx={{
            fontWeight: Fonts.MEDIUM,
            ...(hideCancel && {
              backgroundColor: '#191919',
              color: '#fff',
              minWidth: '120px',
              '&:hover': {
                backgroundColor: '#000',
              },
            }),
          }}
          onClick={onConfirm}
          color="primary"
          autoFocus
          disabled={confirmDisabled}
        >
          {confirmTitle ? confirmTitle : <IntlMessages id="common.yes" />}
        </Button>
        {!hideCancel && (
          <Button
            variant="outlined"
            sx={{
              fontWeight: Fonts.MEDIUM,
            }}
            onClick={() => onDeny(false)}
            color="secondary"
          >
            {denyTitle ? denyTitle : <IntlMessages id="common.no" />}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AppConfirmDialog;
